import { useMutation, useQueryClient } from '@tanstack/react-query';

import { schedulesApi, type BulkMembersRequest } from '../api/schedules-api';

import { refreshSchedule } from './invalidate';
import { scheduleKeys } from './schedule-keys';

/**
 * Pin, unpin, exclude, include or remove the selected members. Answers a `BulkResponse` whatever
 * the transport (`schedulesApi.bulkMembers` loops over single calls until the bulk endpoint
 * lands); excluding or removing a live member runs a release run, so runs refetch too.
 */
export function useBulkScheduleMembers(id: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: BulkMembersRequest) => schedulesApi.bulkMembers(id, request),
    meta: { silentError: true },
    onSettled: () =>
      Promise.all([
        refreshSchedule(queryClient, id),
        queryClient.invalidateQueries({ queryKey: scheduleKeys.members(id) }),
        queryClient.invalidateQueries({ queryKey: scheduleKeys.runs(id) }),
      ]),
  });
}
